export interface ResourceArticleMeta {
    slug: string;
    title: string;
    excerpt: string;
    image: string;
    translationKey: string;
}

export const resourcesArticles: ResourceArticleMeta[] = [
    {
        slug: 'giving-with-purpose',
        title: 'Giving with Purpose: How Your Faith Transforms Every Contribution',
        excerpt: 'Discover how faith-driven giving deepens impact and blesses communities.',
        image: '/resources/1-fellowship.jpg',
        translationKey: 'givingWithPurpose',
    },
    {
        slug: 'smart-giving-guide',
        title: 'Smart Giving: Your Guide to Effective Christian Donations',
        excerpt: 'Practical steps to steward generosity wisely and maximize kingdom impact.',
        image: '/resources/4-bible.jpg',
        translationKey: 'smartGivingGuide',
    },
    {
        slug: 'strategic-stewardship',
        title: 'Strategic Stewardship: A Christian Guide to Maximizing Your Impact',
        excerpt: 'Biblical principles and strategies for intentional, impactful generosity.',
        image: '/resources/2-generosity.jpg',
        translationKey: 'strategicStewardship',
    },
    {
        slug: 'supporting-your-local-church',
        title: 'The Cornerstone of Community: Why Supporting Your Local Church Matters',
        excerpt: 'Why local church giving strengthens faith, community, and mission.',
        image: '/resources/3-community.jpg',
        translationKey: 'supportingLocalChurch',
    },
    {
        slug: 'true-cost-missionary-fundraising-platforms-2026',
        title: 'The True Cost of Every Missionary Fundraising Platform in 2026',
        excerpt: 'An honest, all-in fee comparison of eight missionary fundraising platforms — including where Devotion Fund is the wrong choice.',
        image: '/resources/cover14.jpg',
        translationKey: 'trueCostMissionaryFundraisingPlatforms2026',
    },
    {
        slug: 'how-to-write-a-missionary-support-letter',
        title: 'How to Write a Missionary Support Letter That Actually Gets You Funded',
        excerpt: 'A step-by-step guide with a real template and the six mistakes that quietly kill most support letters.',
        image: '/resources/cover3.jpg',
        translationKey: 'howToWriteAMissionarySupportLetter',
    },
    {
        slug: 'how-to-write-a-prayer-letter-people-actually-read',
        title: 'How to Write a Prayer Letter People Actually Read',
        excerpt: 'Seven writing moves that turn a prayer letter donors skim into one they finish, remember, and reply to.',
        image: '/resources/cover5.jpg',
        translationKey: 'howToWriteAPrayerLetterPeopleActuallyRead',
    },
    {
        slug: 'how-to-start-monthly-giving-page-without-501c3',
        title: 'How to Start a Monthly Giving Page as a Missionary (Without Becoming a 501(c)(3))',
        excerpt: 'Three legitimate paths to receiving monthly support without forming your own nonprofit — compared honestly.',
        image: '/resources/cover6.jpg',
        translationKey: 'howToStartAMonthlyGivingPageWithout501c3',
    },
    {
        slug: 'givesendgo-vs-devotion-fund',
        title: 'GiveSendGo vs Devotion Fund: Which Is Right for Christian Fundraising in 2026?',
        excerpt: "An honest comparison from a competing founder — where GiveSendGo's 0% headline wins, and where recurring support tooling wins instead.",
        image: '/resources/cover7.jpg',
        translationKey: 'givesendgoVsDevotionFund',
    },
    {
        slug: 'gofundme-alternatives-for-missionaries',
        title: 'GoFundMe Alternatives for Missionaries: 8 Platforms Compared (2026)',
        excerpt: 'An honest, founder-written comparison of eight platforms missionaries actually use, with the real fees and a decision tree for which one fits you.',
        image: '/resources/cover2.jpg',
        translationKey: 'gofundmeAlternativesForMissionaries',
    },
    {
        slug: 'continue-to-give-vs-devotion-fund',
        title: 'Continue to Give vs Devotion Fund: A Brutally Honest Comparison (2026)',
        excerpt: "Where Continue to Give's lower raw fees win, and where recurring-first tooling wins instead — from a founder with skin in the game.",
        image: '/resources/cover4.jpg',
        translationKey: 'continueToGiveVsDevotionFund',
    },
    {
        slug: 'free-missionary-newsletter-template',
        title: 'Free Missionary Newsletter Template + 3 Real Examples Teardown',
        excerpt: 'A free, copy-paste newsletter template plus a teardown of three common mistakes and the one fix that doubles donor engagement.',
        image: '/resources/cover13.jpg',
        translationKey: 'freeMissionaryNewsletterTemplate',
    },
    {
        slug: 'mission-trip-fundraising-ideas',
        title: 'Mission Trip Fundraising Ideas: 11 Ways to Raise Support for a Short-Term Trip (2026)',
        excerpt: 'Eleven practical ways to fund a short-term mission trip, plus an honest answer on when a one-time crowdfunding page beats a support letter.',
        image: '/resources/cover15.jpg',
        translationKey: 'missionTripFundraisingIdeas',
    },
    {
        slug: 'how-long-to-raise-full-support-as-a-missionary',
        title: 'How Long Does It Take to Raise Full Support as a Missionary? A Realistic Timeline',
        excerpt: "An honest, month-by-month look at how long full-support fundraising actually takes, the factors that speed it up or stall it, and what to do when it's taking longer than planned.",
        image: '/resources/cover16.jpg',
        translationKey: 'howLongToRaiseFullSupportAsAMissionary',
    },
    {
        slug: 'how-much-support-does-a-missionary-need',
        title: 'How Much Support Does a Missionary Need? A Realistic Monthly Budget Breakdown',
        excerpt: 'A practical framework for building your monthly missionary support budget — the categories most first-time budgets miss and how to land on a defensible number.',
        image: '/resources/cover17.jpg',
        translationKey: 'howMuchSupportDoesAMissionaryNeed',
    },
    {
        slug: 'patreon-vs-devotion-fund',
        title: 'Patreon vs Devotion Fund: Which Is Better for Missionary Support in 2026?',
        excerpt: "An honest comparison from a competing founder: Patreon's real 13-16% all-in cost vs Devotion Fund's 5-7% all-in, and why the category mismatch matters more than the fee gap.",
        image: '/resources/cover9.jpg',
        translationKey: 'patreonVsDevotionFund',
    },
    {
        slug: 'modern-day-missions-vs-devotion-fund',
        title: 'Modern Day Missions vs Devotion Fund: Fiscal Sponsor or Direct Support Platform?',
        excerpt: "An honest comparison from a competing founder: Modern Day Missions' tax-deductible fiscal sponsorship vs Devotion Fund's direct, recurring-first support platform.",
        image: '/resources/cover12.jpg',
        translationKey: 'modernDayMissionsVsDevotionFund',
    },
    {
        slug: 'is-missionary-support-tax-deductible',
        title: 'Is Missionary Support Tax-Deductible? A Clear Guide for Donors and Missionaries (2026)',
        excerpt: "A plain-English guide to when missionary support is actually tax-deductible, when it isn't, and why the answer depends on the giving structure, not the missionary or the cause.",
        image: '/resources/cover18.jpg',
        translationKey: 'isMissionarySupportTaxDeductible',
    },
    {
        slug: 'how-to-ask-your-church-to-support-you-as-a-missionary',
        title: 'How to Ask Your Church to Support You as a Missionary (Step-by-Step)',
        excerpt: "A practical, step-by-step guide to approaching your pastor and missions committee about becoming a sent and supported missionary — what to bring, what they'll ask, and how to follow up.",
        image: '/resources/cover19.jpg',
        translationKey: 'howToAskYourChurchToSupportYouAsAMissionary',
    },
    {
        slug: 'pure-charity-vs-devotion-fund',
        title: 'Pure Charity vs Devotion Fund: Sending Organization or Individual Support Platform?',
        excerpt: "An honest comparison from a competing founder: Pure Charity's org-level, custom-priced infrastructure vs Devotion Fund's self-serve, flat-5% platform for the individual missionary.",
        image: '/resources/cover20.jpg',
        translationKey: 'pureCharityVsDevotionFund',
    },
    {
        slug: 'how-to-ask-friends-and-family-to-support-your-mission-trip',
        title: 'How to Ask Friends and Family to Support Your Mission Trip Without Feeling Awkward',
        excerpt: 'A practical script and mindset shift for asking the people closest to you to support a mission trip — what to say, which channel to use, and how to handle a no.',
        image: '/resources/cover21.jpg',
        translationKey: 'howToAskFriendsAndFamilyToSupportYourMissionTrip',
    },
    {
        slug: 'single-missionary-support-raising',
        title: 'Single Missionary Support Raising: 9 Things That Are Different (and How to Handle Them)',
        excerpt: "A practical guide for single missionaries raising personal support — the nine things that work differently without a spouse's network, and how to handle each one.",
        image: '/resources/cover22.jpg',
        translationKey: 'singleMissionarySupportRaising',
    },
    {
        slug: 'how-to-write-a-missionary-thank-you-letter',
        title: 'How to Write a Missionary Thank-You Letter Donors Actually Remember',
        excerpt: 'A practical guide to writing donor thank-you letters that build long-term missionary support, with a simple template you can reuse for every gift.',
        image: '/resources/cover23.jpg',
        translationKey: 'howToWriteAMissionaryThankYouLetter',
    },
    {
        slug: 'missionary-couple-support-raising',
        title: 'Missionary Support Raising as a Couple: 7 Things to Get Right Together',
        excerpt: "A practical guide for married missionary couples raising support together — combining two networks, telling one story, and dividing the work so one spouse doesn't carry it alone.",
        image: '/resources/cover24.jpg',
        translationKey: 'missionaryCoupleSupportRaising',
    },
    {
        slug: 'is-it-biblical-to-ask-for-support',
        title: 'Is It Biblical to Ask People for Money as a Missionary?',
        excerpt: 'A plain, scripture-grounded answer to the question almost every missionary asks privately before their first support letter goes out.',
        image: '/resources/cover25.jpg',
        translationKey: 'isItBiblicalToAskForSupport',
    },
    {
        slug: 'handling-no-when-asking-for-support',
        title: "How to Handle a 'No' When Asking for Missionary Support",
        excerpt: 'The six reasons people actually decline, how to respond to each one, and why a no rarely means what you think it means.',
        image: '/resources/cover26.jpg',
        translationKey: 'handlingNoWhenAskingForSupport',
    },
    {
        slug: 'introverts-guide-to-support-raising',
        title: "The Introvert's Guide to Support Raising (Without Pretending to Be Someone Else)",
        excerpt: 'A practical approach to raising missionary support if small talk drains you and cold outreach feels impossible — built around written communication and one-on-one conversations instead of a performance.',
        image: '/resources/cover27.jpg',
        translationKey: 'introvertsGuideToSupportRaising',
    },
    {
        slug: 'raise-support-fast-30-60-90-day-plan',
        title: 'How to Raise Support Fast: A 30/60/90-Day Plan for New Missionaries',
        excerpt: 'A realistic 30/60/90-day plan for raising full missionary support quickly — what to build first, who to contact when, and the weekly rhythm that keeps momentum from stalling.',
        image: '/resources/cover11.jpg',
        translationKey: 'raiseSupportFast306090DayPlan',
    },
    {
        slug: 'missionary-furlough-support-raising',
        title: 'Missionary Furlough Support Raising: How to Reconnect With Donors During Home Assignment',
        excerpt: 'A practical guide to using furlough (home assignment) to strengthen donor relationships, refill your support base, and close gaps that opened while you were on the field.',
        image: '/resources/cover28.jpg',
        translationKey: 'missionaryFurloughSupportRaising',
    },
    {
        slug: 'donor-retention-for-missionaries',
        title: 'Donor Retention for Missionaries: How to Stop Supporters From Quietly Lapsing',
        excerpt: "Most missionary support doesn't end with a dramatic cancellation — it fades through silence. A practical guide to the retention habits that keep recurring donors giving year after year.",
        image: '/resources/cover29.jpg',
        translationKey: 'donorRetentionForMissionaries',
    },
    {
        slug: 'second-term-missionary-support-raising',
        title: 'Second-Term Missionary Support Raising: What Changes the Second Time Around',
        excerpt: 'Raising support for a second term is a different task than raising it the first time — a practical guide to re-engaging existing donors, explaining rising costs, and finding new supporters without starting from zero.',
        image: '/resources/cover30.jpg',
        translationKey: 'secondTermMissionarySupportRaising',
    },
    {
        slug: 'follow-up-after-support-raising-appointment',
        title: 'How to Follow Up After a Support-Raising Appointment (Without Being Pushy)',
        excerpt: "A practical guide to following up after a support-raising meeting — what to send, when to send it, and how to ask for a decision without sounding like you're chasing someone down.",
        image: '/resources/cover1.jpg',
        translationKey: 'followUpAfterSupportRaisingAppointment',
    },
    {
        slug: 'bi-vocational-missionary-support-raising',
        title: 'Bi-Vocational Missionary Support Raising: Combining a Job With Donor Support',
        excerpt: "A practical guide to raising missionary support alongside a job — how to size a realistic support goal when you have other income, and how to explain the arrangement to donors so it builds trust instead of raising questions.",
        image: '/resources/cover8.jpg',
        translationKey: 'biVocationalMissionarySupportRaising',
    },
    {
        slug: 'common-mistakes-missionary-support-raising',
        title: '10 Common Mistakes Missionaries Make When Raising Support (and How to Fix Them)',
        excerpt: 'The recurring mistakes that quietly stall missionary support raising — vague asks, no follow-up, a network that never grows — and a practical fix for each one.',
        image: '/resources/cover10.jpg',
        translationKey: 'commonMistakesMissionarySupportRaising',
    },
    {
        slug: 'raising-support-with-no-network',
        title: "How to Raise Missionary Support When You Don't Have a Big Network",
        excerpt: "A practical guide for missionaries who feel like they don't know enough people — how to grow a small starting circle into full support through introductions instead of a bigger address book.",
        image: '/resources/cover31.jpg',
        translationKey: 'raisingSupportWithNoNetwork',
    },
    {
        slug: 'missions-pastor-checklist-vetting-fundraising-platforms',
        title: "A Missions Pastor's Checklist: Vetting Fundraising Platforms for Your Sent Missionaries",
        excerpt: 'Twelve questions every missions pastor or committee should ask before recommending a support-raising platform to a sent missionary — fees, payout speed, data ownership, and the questions vendors hope you skip.',
        image: '/resources/cover19.jpg',
        translationKey: 'missionsPastorChecklistVettingFundraisingPlatforms',
    },
    {
        slug: 'how-to-recover-from-a-missed-newsletter',
        title: 'How to Recover From a Missed Newsletter — A 5-Day Plan for Missionaries',
        excerpt: "A practical 5-day plan for missionaries who let a newsletter or update slip for months — how to re-open contact with donors without a lengthy apology, and turn silence into a fresh update habit.",
        image: '/resources/cover13.jpg',
        translationKey: 'howToRecoverFromAMissedNewsletter',
    },
    {
        slug: 'how-to-ask-for-support-over-text-and-social-media',
        title: 'How to Ask for Support Over Text and Social Media (Without It Feeling Impersonal)',
        excerpt: "A practical guide to asking for missionary support over text message and social media — when it's the right channel, a three-message sequence that doesn't feel like a sales pitch, and what to avoid.",
        image: '/resources/cover6.jpg',
        translationKey: 'howToAskForSupportOverTextAndSocialMedia',
    },
    {
        slug: 'what-to-do-when-a-major-donor-stops-giving',
        title: 'What to Do When a Major Donor Stops Giving',
        excerpt: "A practical guide for missionaries when a large recurring donor stops giving — how to confirm what happened, the four most common reasons, how to respond to each, and how to avoid depending on one gift again.",
        image: '/resources/cover16.jpg',
        translationKey: 'whatToDoWhenAMajorDonorStopsGiving',
    },
    {
        slug: 'how-to-ask-a-one-time-donor-to-become-a-monthly-supporter',
        title: 'How to Ask a One-Time Donor to Become a Monthly Supporter',
        excerpt: 'A practical script and timing guide for converting a one-time gift into recurring monthly support — when to ask, what to say, and why the second ask is easier than the first.',
        image: '/resources/cover20.jpg',
        translationKey: 'howToAskAOneTimeDonorToBecomeAMonthlySupporter',
    },
    {
        slug: 'year-end-giving-reminder-for-missionaries',
        title: 'Year-End Giving: How to Remind Donors Before December 31 (Without Sounding Pushy)',
        excerpt: 'A practical timeline and message templates for reminding donors about year-end giving deadlines — when to send each message, what to say, and how to do it without sounding like a fundraising campaign.',
        image: '/resources/cover14.jpg',
        translationKey: 'yearEndGivingReminderForMissionaries',
    },
    {
        slug: 'what-happens-if-you-dont-reach-full-support',
        title: "What Happens If You Don't Reach Full Support? A Missionary's Options",
        excerpt: "A practical, honest look at what actually happens when a missionary hits their departure date without full support — the real options, how sending organizations handle it, and how to keep raising support without losing momentum.",
        image: '/resources/cover17.jpg',
        translationKey: 'whatHappensIfYouDontReachFullSupport',
    },
    {
        slug: 'diversify-missionary-support-sources',
        title: "How to Diversify Missionary Support So One Donor or Church Can't Sink Your Budget",
        excerpt: "A practical guide to spreading missionary support across enough donors and churches that losing any single one is a dip, not a crisis — including a simple concentration test you can run today.",
        image: '/resources/cover31.jpg',
        translationKey: 'diversifyMissionarySupportSources',
    },
    {
        slug: 'giving-tuesday-for-missionaries',
        title: "GivingTuesday for Missionaries: A Simple Plan to Capture the Year's Biggest Giving Day",
        excerpt: "A practical, low-pressure plan for missionaries to use GivingTuesday — the save-the-date message, the day-of ask, and the same-day thank-you — without turning support raising into a marketing campaign.",
        image: '/resources/cover6.jpg',
        translationKey: 'givingTuesdayForMissionaries',
    },
    {
        slug: 'how-to-ask-a-business-to-sponsor-your-mission-trip',
        title: 'How to Ask a Business to Sponsor Your Mission Trip (Without It Feeling Like a Cold Pitch)',
        excerpt: "A practical guide to asking a local business to sponsor your mission trip — which businesses to approach first, what to offer in return, and a simple one-page ask that doesn't turn into a marketing negotiation.",
        image: '/resources/cover9.jpg',
        translationKey: 'howToAskABusinessToSponsorYourMissionTrip',
    },
    {
        slug: 'how-to-ask-for-a-support-increase',
        title: 'How to Ask Your Donors for a Support Increase (Without Feeling Guilty)',
        excerpt: "A practical guide to asking existing donors to raise their giving — when cost-of-living catches up with your support, how to frame the ask so it doesn't feel like a complaint, and a simple script that keeps the relationship intact either way.",
        image: '/resources/cover1.jpg',
        translationKey: 'howToAskForASupportIncrease',
    },
    {
        slug: 'what-to-do-when-a-donors-card-expires',
        title: "What to Do When a Donor's Card Expires — Before It Silently Cancels Their Gift",
        excerpt: "A practical guide to handling expired or declined donor cards — why recurring gifts quietly stop without anyone deciding to stop giving, how to catch it early, and a short, low-pressure message that gets the gift restarted.",
        image: '/resources/cover2.jpg',
        translationKey: 'whatToDoWhenADonorsCardExpires',
    },
    {
        slug: 'how-to-write-a-fundraising-page-bio-that-gets-donations',
        title: 'How to Write a Fundraising Page Bio That Gets People to Give (With Examples)',
        excerpt: "Your fundraising page bio does more work than any single support letter — it's what a donor reads right before deciding to give. A practical structure, two before/after examples, and the mistakes that quietly cost you donations.",
        image: '/resources/cover3.jpg',
        translationKey: 'howToWriteAFundraisingPageBio',
    },
    {
        slug: 'how-often-to-update-supporters-newsletter-cadence',
        title: 'How Often Should You Update Your Supporters? Finding the Right Newsletter Cadence',
        excerpt: "Too many updates feels needy; too few and donors quietly forget why they're giving. A practical framework for picking — and actually keeping — a support-update cadence that fits your ministry and your bandwidth.",
        image: '/resources/cover13.jpg',
        translationKey: 'howOftenToUpdateSupportersNewsletterCadence',
    },
    {
        slug: 'how-many-donors-do-you-need-for-full-support',
        title: 'How Many Donors Do You Need to Reach Full Support? A Simple Math-First Framework',
        excerpt: "Most missionaries size their support goal in dollars and stall on donor count. A practical framework for working backward from your monthly number to how many supporters you actually need — and at what gift size.",
        image: '/resources/cover11.jpg',
        translationKey: 'howManyDonorsDoYouNeedForFullSupport',
    },
    {
        slug: 'missionary-prayer-card-what-to-include',
        title: 'What to Put on a Missionary Prayer Card (And How to Actually Use It)',
        excerpt: "A prayer card is often the only thing a potential supporter keeps. What to include, what to leave off, and how to get it into the hands of people who'll actually pray — and give.",
        image: '/resources/cover25.jpg',
        translationKey: 'missionaryPrayerCard',
    },
    {
        slug: 'who-owns-your-donor-data-missionary-fundraising',
        title: 'Who Owns Your Donor Data? What Missionaries Should Ask Before Choosing a Platform',
        excerpt: 'If you ever change platforms, sending organizations, or fields, can you take your donor list with you? A practical checklist for a question most missionaries never ask until it is too late.',
        image: '/resources/cover9.jpg',
        translationKey: 'whoOwnsYourDonorData',
    },
    {
        slug: 'what-to-do-when-support-raising-plateaus',
        title: 'What to Do When Your Support Raising Plateaus at 70-80%',
        excerpt: 'Getting from zero to most of the way there is often the easy part. Why support raising stalls just short of full support, and a practical plan for closing the last 20-30%.',
        image: '/resources/cover13.jpg',
        translationKey: 'whatToDoWhenSupportRaisingPlateaus',
    },
    {
        slug: 'do-missionaries-pay-taxes-on-support',
        title: 'Do Missionaries Pay Taxes on Support Income? A Plain-English Guide',
        excerpt: "Missionary support is usually taxable income to the person receiving it, even though it comes from gifts. A clear look at why, how W-2 and self-employed missionaries are taxed differently, and what records to keep.",
        image: '/resources/cover18.jpg',
        translationKey: 'doMissionariesPayTaxesOnSupport',
    },
    {
        slug: 'how-to-explain-platform-fees-to-your-donors',
        title: 'How to Explain Platform Fees to Your Donors (Without It Feeling Awkward)',
        excerpt: 'A donor asking "how much of this actually reaches you?" is a good sign, not a challenge. A practical script for explaining fees honestly, plus why transparency about the cut usually builds more trust than dodging the question.',
        image: '/resources/cover7.jpg',
        translationKey: 'howToExplainPlatformFeesToYourDonors',
    },
    {
        slug: 'missionary-support-packet-what-to-include',
        title: 'What to Include in a Missionary Support Packet (And What to Leave Out)',
        excerpt: "A missionary support packet is more than a letter. What actually belongs in one — the letter, the budget, the giving options, the photo — and the extras that slow people down instead of moving them to give.",
        image: '/resources/cover5.jpg',
        translationKey: 'missionarySupportPacketWhatToInclude',
    },
    {
        slug: 'missionary-support-raising-for-families-with-kids',
        title: 'Missionary Support Raising for Families With Kids',
        excerpt: "Raising support with children changes the math, the story, and the schedule. What's different when you're fundraising as a family — budgeting for kids, involving them in the story honestly, and pacing a campaign around school and travel.",
        image: '/resources/cover8.jpg',
        translationKey: 'missionarySupportRaisingForFamiliesWithKids',
    },
    {
        slug: 'missionary-support-raising-during-a-recession',
        title: 'How to Raise Missionary Support During a Recession (Without Panicking Your Donors)',
        excerpt: "When the economy tightens, donors don't stop giving — they get more careful about who they give to. What actually changes in a downturn, what doesn't, and how to keep support raising steady when the news is bad.",
        image: '/resources/cover10.jpg',
        translationKey: 'missionarySupportRaisingDuringARecession',
    },
    {
        slug: 'sending-agency-vs-independent-missionary',
        title: 'Sending Agency vs. Going Independent: How Missionaries Should Choose',
        excerpt: "Going through a sending agency and raising support independently solve different problems. A practical look at what each actually gives you — accountability, cost, speed, and control — so you can pick with your eyes open.",
        image: '/resources/cover22.jpg',
        translationKey: 'sendingAgencyVsIndependentMissionary',
    },
    {
        slug: 'how-to-make-a-missionary-support-raising-video',
        title: 'How to Make a Missionary Support-Raising Video (Script + Filming Tips)',
        excerpt: "A short, honest video often out-performs a long letter for getting a first response. A practical script structure, filming tips that don't require any equipment, and where to actually send it.",
        image: '/resources/cover24.jpg',
        translationKey: 'howToMakeAMissionarySupportRaisingVideo',
    },
    {
        slug: 'how-to-ask-a-small-group-or-sunday-school-class-to-support-you',
        title: 'How to Ask a Small Group or Sunday School Class to Support You as a Missionary',
        excerpt: "A small group or Sunday school class isn't a mini-church service and isn't a one-on-one coffee either. A practical guide to getting on the schedule, structuring a short ask, and following up with a group instead of an individual.",
        image: '/resources/cover23.jpg',
        translationKey: 'howToAskASmallGroupOrSundaySchoolClassToSupportYou',
    },
    {
        slug: 'how-to-transition-supporters-when-you-change-mission-fields',
        title: 'How to Transition Your Supporters When You Change Mission Fields or Agencies',
        excerpt: "Changing fields or sending organizations is normal for a missionary career, but it can look alarming to a donor who only sees the surface. A timeline and message structure for keeping supporters through the transition instead of losing them to it.",
        image: '/resources/cover25.jpg',
        translationKey: 'howToTransitionSupportersWhenYouChangeMissionFields',
    },
    {
        slug: 'venmo-and-cashapp-for-missionary-support-raising',
        title: "Venmo and Cash App for Missionary Support Raising: Why They're Riskier Than They Look",
        excerpt: "Venmo and Cash App feel like the easy option for collecting missionary support — until a frozen account, a missing tax record, or a confused donor shows the real cost. What actually goes wrong, and what to use instead.",
        image: '/resources/cover7.jpg',
        translationKey: 'venmoAndCashAppForMissionarySupportRaising',
    },
    {
        slug: 'how-to-track-missionary-support-raising-donors',
        title: 'How to Track Your Missionary Support-Raising Donors: Spreadsheet vs. Dedicated Platform',
        excerpt: "A spreadsheet works fine for donor tracking — until it doesn't. What to record for every donor no matter which tool you use, why a spreadsheet is a legitimate place to start, and the signs it's time to move to something built for it.",
        image: '/resources/cover5.jpg',
        translationKey: 'howToTrackMissionarySupportRaisingDonors',
    },
    {
        slug: 'how-to-write-a-missionary-vision-letter',
        title: 'How to Write a Missionary Vision Letter (Case Statement) Before You Ask for Support',
        excerpt: "Before you send a single support letter, you need a vision letter — the foundational document that explains your calling, not just your budget. What it is, why it comes first, and how to write one people actually remember.",
        image: '/resources/cover12.jpg',
        translationKey: 'howToWriteAMissionaryVisionLetter',
    },
    {
        slug: 'missionary-support-raising-launch-checklist',
        title: 'Missionary Support-Raising Launch Checklist: What to Do Before You Go Public',
        excerpt: "A missionary support-raising page you launch before it's ready costs you your best moment — the first time your network sees it. The checklist to run through before you share the link with anyone.",
        image: '/resources/cover15.jpg',
        translationKey: 'missionarySupportRaisingLaunchChecklist',
    },
    {
        slug: 'free-christian-fundraising-platforms-vs-devotion-fund',
        title: 'Free Christian Fundraising Platforms (Ergatas, Outpour) vs Devotion Fund: What "0% Fees" Really Means',
        excerpt: 'An honest look at two genuinely free missionary platforms from a founder who charges 5% — what "0% fees" actually requires of you, and when free is the better answer.',
        image: '/resources/cover4.jpg',
        translationKey: 'freeChristianFundraisingPlatformsVsDevotionFund',
    },
    {
        slug: 'sowfund-vs-devotion-fund',
        title: 'Sowfund vs Devotion Fund: Same 5% Fee, One Big Difference (Tax-Deductible or Not)',
        excerpt: "Sowfund and Devotion Fund both charge 5% — but Sowfund is a 501(c)(3) nonprofit, so gifts through it are tax-deductible and gifts through us aren't. What that structural difference actually means for you.",
        image: '/resources/cover6.jpg',
        translationKey: 'sowfundVsDevotionFund',
    },
    {
        slug: 'hopegives-vs-devotion-fund',
        title: 'HopeGives vs Devotion Fund: 0% Platform Fee, Opt-In Tip, and an AI Writer of Its Own',
        excerpt: 'HopeGives is a newer 0%-fee crowdfunding platform for missionaries, churches, and nonprofits — with its own AI writing tool and a genuinely opt-in donor tip. An honest comparison from a competing founder.',
        image: '/resources/cover7.jpg',
        translationKey: 'hopeGivesVsDevotionFund',
    },
    {
        slug: 'is-missionary-support-tax-deductible-uk',
        title: 'Is Missionary Support Tax-Deductible in the UK? Gift Aid Explained (2026)',
        excerpt: "A plain-English guide for UK donors: when giving to a missionary qualifies for Gift Aid, when it doesn't, and why the answer comes down to who actually receives the gift.",
        image: '/resources/cover18.jpg',
        translationKey: 'isMissionarySupportTaxDeductibleUK',
    },
    {
        slug: 'is-missionary-support-tax-deductible-canada',
        title: 'Is Missionary Support Tax-Deductible in Canada? A Clear Guide for Donors (2026)',
        excerpt: "A plain-English guide for Canadian donors: when a gift to a missionary earns an official donation receipt for the CRA charitable donation tax credit, and when it doesn't.",
        image: '/resources/cover18.jpg',
        translationKey: 'isMissionarySupportTaxDeductibleCanada',
    },
    {
        slug: 'is-missionary-support-tax-deductible-australia',
        title: 'Is Missionary Support Tax-Deductible in Australia? DGR Status Explained (2026)',
        excerpt: "A plain-English guide for Australian donors: why Deductible Gift Recipient (DGR) status decides whether a gift to a missionary is tax-deductible, and how missionary giving is usually structured to qualify.",
        image: '/resources/cover18.jpg',
        translationKey: 'isMissionarySupportTaxDeductibleAustralia',
    },
];


